import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import Home from '../pages/Home';

function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/anime-sticker" element={<Home />} exact />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>
  );
}



export default App;